import React from 'react';
import { Avatar, Box, Typography, SxProps, Theme } from '@mui/material';

/**
 * 代币图标大小枚举
 */
export enum TokenIconSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large'
}

/**
 * 代币图标组件属性接口
 */
interface TokenIconProps {
  /**
   * 代币符号
   */
  symbol: string;
  /**
   * 代币图标URL
   */
  logoUrl?: string;
  /**
   * 图标大小
   */
  size?: TokenIconSize;
  /**
   * 自定义样式
   */
  sx?: SxProps<Theme>;
  /**
   * 是否显示符号
   */
  showSymbol?: boolean;
}

/**
 * 代币图标组件
 * 显示代币的图标和符号
 */
const TokenIcon: React.FC<TokenIconProps> = ({
  symbol,
  logoUrl,
  size = TokenIconSize.MEDIUM,
  sx,
  showSymbol = true
}) => {
  // 根据大小设置尺寸
  const getSizeValue = (): number => {
    switch (size) {
      case TokenIconSize.SMALL:
        return 24;
      case TokenIconSize.LARGE:
        return 40;
      case TokenIconSize.MEDIUM:
      default:
        return 32;
    }
  };

  // 字体大小
  const getFontSize = (): string => {
    switch (size) {
      case TokenIconSize.SMALL:
        return '0.75rem';
      case TokenIconSize.LARGE:
        return '1rem';
      case TokenIconSize.MEDIUM:
      default:
        return '0.875rem';
    }
  };

  // 获取首字母作为备用显示
  const getInitial = (): string => {
    return symbol ? symbol.charAt(0).toUpperCase() : '?';
  };

  const iconSize = getSizeValue();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        ...sx
      }}
    >
      <Avatar
        src={logoUrl}
        alt={symbol}
        sx={{
          width: iconSize,
          height: iconSize,
          fontSize: iconSize * 0.5,
          bgcolor: !logoUrl ? 'primary.main' : undefined,
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
        }}
      >
        {getInitial()}
      </Avatar>
      {showSymbol && (
        <Typography
          variant="body2"
          sx={{
            ml: 1,
            fontWeight: 500,
            fontSize: getFontSize()
          }}
        >
          {symbol}
        </Typography>
      )}
    </Box>
  );
};

export default TokenIcon;
